<template>
  <LayoutDefault>
    <section class="application">
      <h1 class="application__title">Заявка на обучение</h1>
      <div class="application__sample">
        <p>Образец заявки на обучение</p>
        <span>Obrazec_zayavki.doc</span>
      </div>
      <div class="application__politics">
        <p>Политика в сфере обработки персональных данных</p>
        <span>Politika_Personal_Dannye.pdf</span>
      </div>
    </section>
  </LayoutDefault>
</template>

<script>
import LayoutDefault from '@/layout/LayoutDefault'

export default {
  name: 'ApplicationEducationView',
  components: {
    LayoutDefault
  },
  props: {
  },
  setup () {
  }
}
</script>

<style lang="scss" scoped>
.application {

  &__title {
    font-size: 26px;
    font-weight: 600;
    text-align: left;
    margin-bottom: 30px;
  }

  &__sample {
    display: flex;
    width: 50%;
    margin-bottom: 36px;
    text-align: left;

    p {
      flex-grow: 1;
      flex-basis: 45%;
      font-size: 14px;
    }
  }

  &__politics {
    display: flex;
    width: 50%;
    text-align: left;

    p {
      flex-grow: 1;
      flex-basis: 60%;
      font-size: 14px;
    }
  }

  span {
    flex-basis: 55%;
    font-size: 14px;
    color: #1BA6DA;
  }
}
</style>
